export const homeEN = {
  // Hero
  'home.eyebrow': 'Data & AI Transformation Boutique',
  'home.headline': 'Turn Data and AI into {em}real{/em} business results.',
  'home.heroSub': 'We help companies move from {strong}fragmented data and stalled pilots{/strong} to production-grade AI that grows revenue, cuts costs, and improves customer experience — with a clear economic thesis from day one.',
  'home.pill1': 'ROI-First',
  'home.pill2': 'Tech Agnostic',
  'home.pill3': 'Production, Not Pilots',
  'home.pill4': 'PERCEPTYA AI VALUE SYSTEM™',

  // Logo strip
  'home.partnersEyebrow': 'Expertises & Certified Partnerships',
  'home.partnersHeadline': 'Deep expertise across the leading {em}Data & AI platforms{/em} — certified professionals distributed globally, ready to accelerate your journey regardless of your stack or stage.',

  // Problem section
  'home.problemLabel': 'Why AI Initiatives Stall',
  'home.problemHeadline': 'Most organizations have the ambition.{br}Few have the {em}foundation{/em}.',
  'home.problemSub': "The challenge isn't access to AI tools — it's what comes before: fragmented data, POCs that never reach production, initiatives disconnected from P&L, and governance gaps that block adoption. Perceptya is built to solve exactly this.",

  // Problem cards
  'home.card1Title': 'Fragmented Data',
  'home.card1Body': 'Siloed systems, no single source of truth, data quality that blocks AI at every step.',
  'home.card2Title': 'Pilots That Never Scale',
  'home.card2Body': 'POCs that prove a point but never reach production. Governance gaps. No MLOps.',
  'home.card3Title': 'No Economic Thesis',
  'home.card3Body': 'AI initiatives not connected to revenue, margin, or measurable business outcomes.',
  'home.card4Title': 'Capability & Adoption Gaps',
  'home.card4Body': 'Technical execution without change management, governance, or user adoption.',

  // CTA Strip
  'home.ctaEyebrow': 'Start Here',
  'home.ctaHeadline': 'Ready to find out where AI creates{br}{em}real value{/em} for your business?',
  'home.ctaSub': "The AI Value Discovery is the starting point. 6–10 weeks. Executive clarity. A structured plan backed by economic modeling — not a slide deck.",
  'home.stat1Value': '6–10w',
  'home.stat1Label': 'Fixed Discovery Scope',
  'home.stat2Value': '10–36mo',
  'home.stat2Label': 'AI Roadmap Delivered',
  'home.stat3Label': 'Industrialization Modules',
  'home.stat4Label': 'ROI Tracked From Day One',
} as const;

export const homePT = {
  // Hero
  'home.eyebrow': 'Consultoria Boutique de Transformação em Data & AI',
  'home.headline': 'Transforme Dados e IA em resultados de negócio {em}reais{/em}.',
  'home.heroSub': 'Ajudamos empresas a sair de {strong}dados fragmentados e pilotos estagnados{/strong} para IA em escala de produção que aumenta receita, reduz custos e melhora a experiência do cliente — com uma tese econômica clara desde o primeiro dia.',
  'home.pill1': 'ROI-First',
  'home.pill2': 'Tech Agnostic',
  'home.pill3': 'Produção, Não Pilotos',
  'home.pill4': 'PERCEPTYA AI VALUE SYSTEM™',

  // Logo strip
  'home.partnersEyebrow': 'Expertises & Parcerias Certificadas',
  'home.partnersHeadline': 'Expertise profunda nas principais {em}plataformas de Data & AI{/em} — profissionais certificados distribuídos globalmente, prontos para acelerar sua jornada independentemente da sua stack ou estágio.',

  // Problem section
  'home.problemLabel': 'Por Que Iniciativas de IA Estagnam',
  'home.problemHeadline': 'A maioria das organizações tem a ambição.{br}Poucas têm a {em}fundação{/em}.',
  'home.problemSub': 'O desafio não é acesso a ferramentas de IA — é o que vem antes: dados fragmentados, POCs que nunca chegam à produção, iniciativas desconectadas do P&L e lacunas de governança que bloqueiam a adoção. A Perceptya foi criada para resolver exatamente isso.',

  // Problem cards
  'home.card1Title': 'Dados Fragmentados',
  'home.card1Body': 'Sistemas isolados, sem fonte única de verdade, qualidade de dados que bloqueia a IA em cada etapa.',
  'home.card2Title': 'Pilotos Que Nunca Escalam',
  'home.card2Body': 'POCs que provam um ponto mas nunca chegam à produção. Lacunas de governança. Sem MLOps.',
  'home.card3Title': 'Sem Tese Econômica',
  'home.card3Body': 'Iniciativas de IA não conectadas a receita, margem ou resultados de negócio mensuráveis.',
  'home.card4Title': 'Lacunas de Capacidade & Adoção',
  'home.card4Body': 'Execução técnica sem gestão de mudança, governança ou adoção pelos usuários.',

  // CTA Strip
  'home.ctaEyebrow': 'Comece Aqui',
  'home.ctaHeadline': 'Pronto para descobrir onde a IA gera{br}{em}valor real{/em} para o seu negócio?',
  'home.ctaSub': 'O AI Value Discovery é o ponto de partida. 6–10 semanas. Clareza executiva. Um plano estruturado respaldado por modelagem econômica — não uma apresentação.',
  'home.stat1Value': '6–10s',
  'home.stat1Label': 'Escopo Fixo de Discovery',
  'home.stat2Value': '10–36m',
  'home.stat2Label': 'Roadmap de IA Entregue',
  'home.stat3Label': 'Módulos de Industrialização',
  'home.stat4Label': 'ROI Rastreado Desde o Dia Um',
} as const;

export const homeES = {
  // Hero
  'home.eyebrow': 'Consultoría Boutique de Transformación en Data & AI',
  'home.headline': 'Transforme Datos e IA en resultados de negocio {em}reales{/em}.',
  'home.heroSub': 'Ayudamos a las empresas a pasar de {strong}datos fragmentados y pilotos estancados{/strong} a IA de grado productivo que aumenta ingresos, reduce costos y mejora la experiencia del cliente — con una tesis económica clara desde el primer día.',
  'home.pill1': 'ROI-First',
  'home.pill2': 'Tech Agnostic',
  'home.pill3': 'Producción, No Pilotos',
  'home.pill4': 'PERCEPTYA AI VALUE SYSTEM™',

  // Logo strip
  'home.partnersEyebrow': 'Expertises & Alianzas Certificadas',
  'home.partnersHeadline': 'Experiencia profunda en las principales {em}plataformas de Data & AI{/em} — profesionales certificados distribuidos globalmente, listos para acelerar su camino sin importar su stack o etapa.',

  // Problem section
  'home.problemLabel': 'Por Qué las Iniciativas de IA se Estancan',
  'home.problemHeadline': 'La mayoría de las organizaciones tienen la ambición.{br}Pocas tienen la {em}base{/em}.',
  'home.problemSub': 'El desafío no es el acceso a herramientas de IA — es lo que viene antes: datos fragmentados, POCs que nunca llegan a producción, iniciativas desconectadas del P&L y brechas de gobernanza que bloquean la adopción. Perceptya fue creada para resolver exactamente esto.',

  // Problem cards
  'home.card1Title': 'Datos Fragmentados',
  'home.card1Body': 'Sistemas aislados, sin fuente única de verdad, calidad de datos que bloquea la IA en cada paso.',
  'home.card2Title': 'Pilotos Que Nunca Escalan',
  'home.card2Body': 'POCs que demuestran un punto pero nunca llegan a producción. Brechas de gobernanza. Sin MLOps.',
  'home.card3Title': 'Sin Tesis Económica',
  'home.card3Body': 'Iniciativas de IA no conectadas a ingresos, margen o resultados de negocio medibles.',
  'home.card4Title': 'Brechas de Capacidad & Adopción',
  'home.card4Body': 'Ejecución técnica sin gestión del cambio, gobernanza o adopción por los usuarios.',

  // CTA Strip
  'home.ctaEyebrow': 'Comience Aquí',
  'home.ctaHeadline': '¿Listo para descubrir dónde la IA genera{br}{em}valor real{/em} para su negocio?',
  'home.ctaSub': 'El AI Value Discovery es el punto de partida. 6–10 semanas. Claridad ejecutiva. Un plan estructurado respaldado por modelado económico — no una presentación.',
  'home.stat1Value': '6–10s',
  'home.stat1Label': 'Alcance Fijo de Discovery',
  'home.stat2Value': '10–36m',
  'home.stat2Label': 'Roadmap de IA Entregado',
  'home.stat3Label': 'Módulos de Industrialización',
  'home.stat4Label': 'ROI Rastreado Desde el Día Uno',
} as const;
